import { Component, Input, ViewChild } from '@angular/core';
import { ColDef, ColGroupDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { GridComponent } from '../grid/grid.component';

@Component({
  selector: 'app-readonly-grid',
  templateUrl: './readonly-grid.component.html',
  styleUrl: './readonly-grid.component.scss',
})
export class ReadonlyGridComponent {
  @ViewChild(GridComponent) grid: GridComponent;
  @Input() stateKey: string;
  @Input() header: string;
  @Input() gridCssClass: string;
  @Input() columnDefs?: (ColDef | ColGroupDef)[] = [];
  @Input() rowData: any = [];
  @Input() sizeToFit = false;

  get gridStateKey() {
    return `Readonly.${this.stateKey ?? this.header}`;
  }
}
